module.exports = __webpack_public_path__ + "static/step-3-370ff3eb63c8721f83f079d747376a4b.png";